export enum InsuranceVariant {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}
